import { i18n } from "@/plugins/i18n";
import { Callback, TableAction } from "helix-vue-components";

class ThirdPartyActionService {
  public getRowActions(
    deleteIntegration: Callback,
    editClient: Callback,
    toggleActive: Callback
  ): TableAction[] {
    return [
      {
        icon: "fal fa-pencil",
        class: "table__actions",
        action: editClient,
        tooltip: i18n.t("client_integrations.edit_client").toString()
      },
      {
        icon: "fal fa-trash",
        class: "table__actions",
        tooltip: i18n.t("client_integrations.confirm_delete").toString(),
        modalActions: {
          modalNumber: 1,
          modalQuestion: i18n
            .t("client_integrations.cofirm_delete_text")
            .toString(),
          modalSuccessText: i18n.t("yes").toString(),
          modalCancelText: i18n.t("no").toString(),
          modalSuccessAction: deleteIntegration
        }
      },
      {
        icon: "",
        switch: "is_active",
        class: "test mt-3",
        action: (_, id) => toggleActive(id),
        tooltip: i18n.t("client_integrations.toggle_active").toString()
      }
    ];
  }

  public getGeneralActions(addClient: Callback): TableAction[] {
    return [
      {
        id: "add-client-btn",
        icon: "fal fa-plus",
        action: addClient
      }
    ];
  }
}

const thirdPartyActionService = new ThirdPartyActionService();
export default thirdPartyActionService;
